import React from 'react'

const Linked_list = () => {
    return (
        <div className='container'>
            <h1>Linked List Program in C</h1>
            <div className='containers'>
            <p>A linked list is a sequence of data structures, which are connected
                 together via links. Linked List is a sequence of links which contains
                  items. Each link contains a connection to another link. Linked list 
                  is the second most-used data structure after array.</p> <br />
                  </div>
                  <div className='containers'>

 <code className='library'>  #include </code> &lt;stdio.h&gt; <br />
 <code className='library'>#include</code> &lt;string.h&gt;<br />
 <code className='library'>#include</code> &lt;stdlib.h&gt;<br />
 <code className='library'>#include</code> &lt;stdbool.h&gt;<br />
<br />
<code className='keywords'>struct</code> node &#123;<br />
<code className='keywords'> int</code> data;<br />
<code className='keywords'> int</code> key;<br />
<code className='keywords'> struct</code> node *next;<br />
&#125;;<br />

<code className='keywords'>struct</code> node *head = NULL;<br />
<code className='keywords'>struct</code> node *current = NULL;<br />
<br />
<code className='comment'>//display the list</code><br />
<code className='keywords'>void</code> printList() &#123;<br />
<code className='keywords'> struct</code> node *ptr = head;<br />
<code className='library'> printf</code>("\n[ ");<br />
   <br />
   <code className='comment'>//start from the beginning</code><br />
   <code className='keywords '>while</code>(ptr != NULL) &#123;<br />
   <code className='library'>  printf</code>("(%d,%d) ",ptr-&gt;key,ptr-&gt;data);<br />
      ptr = ptr-&gt;next;<br />
   &#125;<br />
   <br />
   <code className='library'>printf</code>(" ]");<br />
&#125;<br />
<br />
<code className='comment'>//insert link at the first location</code><br />
<code className='keywords'>void</code> insertFirst(int key, int data) &#123;<br />
<code className='comment'> //create a link</code><br />
<code className='library'> struct</code> node *link = (struct node*) malloc(sizeof(struct node));<br />
   <br />
   <code className='library'> link</code>-&gt;key = key;<br />
   <code className='library'> link</code>-&gt;data = data;<br />
   <br />
   <code className='comment'> //point it to old first node</code><br />
   <code className='library'> link</code>-&gt;next = head;<br />
   <br />
   <code className='comment'>//point first to new first node</code><br />
             head = link;<br />
&#125;<br />
<br />
<code className='comment'>//delete first item</code><br />
<code className='keywords'>struct </code> node* deleteFirst() &#123;<br />
<br />
<code className='comment'> //save reference to first link</code><br />
<code className='library'> struct </code> node *tempLink = head;<br />
   <br />
   <code className='comment'> //mark next to first link as first</code> <br />
   head = head-&gt;next;<br />
   <br />
   <code className='keywords'>//return the deleted link</code><br />
   <code className='library'> return</code> tempLink;<br />
&#125;<br />
<br />
<code className='comment'>//is list empty</code><br />
<code className='keywords'>bool</code> isEmpty() &#123;<br />
<code className='library'> return</code> head == NULL;<br />
&#125;<br />
<br />
<code className='keywords'>int </code>length() &#123;<br />
<code className='keywords'>   int</code> length = 0;<br />
<code className='keywords'>  struct</code> node *current;<br />
   <br />
   <code className='keywords'> for</code>(current = head; current != NULL; current = current-&gt;next) &#123;<br />
      length++;<br />
   &#125;<br />
   <br />
   <code className='library'>return </code> length;<br />
&#125;<br />
<br />
<code className='comment'>//find a link with given key</code><br />
<code className='keywords'>struct</code> node* find(int key) &#123;<br />
<br />
<code className='comment'> //start from the first link</code><br />
   struct node* current = head;<br />
   <br />
   <code className='comment'>//if list is empty</code> <br />
   <code className='library'> if</code>(head == NULL) &#123;<br />
   <code className='library'>  return</code> NULL;<br />
   &#125;<br />
   <br />
   <code className='comment'> //navigate through list</code><br />
   <code className='keywords'> while</code>(current-&gt;key != key) &#123;<br />
   <br />
   <code className='comment'> //if it is last node </code><br />
   <code className='keywords'>if</code> (current-&gt;next == NULL) &#123;<br />
   <code className='library'>    return </code> NULL;<br />
      &#125; else &#123;<br />
      <code className='comment'>    //go to next link</code><br />
         current = current-&gt;next;<br />
      &#125;<br />
   &#125;      <br />
   <br />
   <code className='comment'> //if data found, return the current Link</code><br />
   <code className='library'> return</code> current;<br />
&#125;<br />
<br />
<code className='comment'>//delete a link with given key</code><br />
struct node* delete(int key) &#123;<br />
<br />
<code className='comment'>//start from the first link</code><br />
   struct node* current = head;<br />
   struct node* previous = NULL;<br />
   <br />
   <code className='comment'>//if list is empty</code> <br />
   <code className='keywords'>if</code>(head == NULL) &#123;<br />
   <code className='library'>  return</code> NULL;<br />
   &#125;<br />
   <br />
   <code className='comment'>//navigate through list</code><br />
   <code className='keywords'> while</code>(current-&gt;key != key) &#123;<br />
   <br />
   <code className='comment'> //if it is last node</code><br />
   <code className='library'> if</code>(current-&gt;next == NULL) &#123;<br />
   <code className='library'>   return</code> NULL;<br />
      &#125; <code className='library'> else </code>&#123;<br />
      <code className='comment'> //store reference to current link</code><br />
         previous = current;<br />
         <code className='comment'>  //move to next link </code><br />
         current = current-&gt;next;<br />
      &#125;<br />
   &#125;<br />
   <br />
   <code className='comment'>//found a match, update the link</code><br />
   <code className='library'>  if</code>(current == head) &#123;<br />
   <code className='comment'>   //change first to point to next link</code><br />
      head = head-&gt;next;<br />
   &#125; <code className='keywords'>else</code>  &#123;<br />
   <code className='comment'> //bypass the current link</code><br />
      previous-&gt;next = current-&gt;next;<br />
   &#125;    <br />
   <br />
   <code className='library'> return</code> current;<br />
&#125;<br />
<br />
<code className='keywords'>void</code> sort() <br />&#123;<br />
<br />
<code className='keywords'>  int</code> i, j, k, tempKey, tempData;<br />
   struct node *current;<br />
   struct node *next;<br />
   <br />
   <code className='keywords'>  int</code> size = length();<br />
   k = size ;<br />
   <br />
   <code className='keywords'> for</code> ( i = 0 ; i &lt; size - 1 ; i++, k-- ) &#123;<br />
      current = head;<br />
      next = head-&gt;next;<br />
		
      <code className='keywords'>    for</code> ( j = 1 ; j &lt; k ; j++ ) &#123;   <br />

      <code className='keywords'>  if</code> ( current-&gt;data &gt; next-&gt;data ) <br />&#123;<br />
            tempData = current-&gt;data;<br />
            current-&gt;data = next-&gt;data;<br />
            next-&gt;data = tempData;<br />
            <br />
            tempKey = current-&gt;key;<br />
            current-&gt;key = next-&gt;key;<br />
            next-&gt;key = tempKey;<br />
         &#125;<br />
         <br />
         current = current-&gt;next;<br />
         next = next-&gt;next;<br />
      &#125;<br />
   &#125;   <br />
&#125;<br />
<br />
<code className='library'>void</code> reverse(struct node** head_ref)<br /> &#123;<br />
   struct node* prev   = NULL;<br />
   struct node* current = *head_ref;<br />
   struct node* next;<br />
   <br />
   <code className='library'> while </code>(current != NULL) <br />&#123;<br />
      next  = current-&gt;next;<br />
      current-&gt;next = prev;   <br />
      prev = current;<br />
      current = next;<br />
   &#125;<br />
   <br />
   *head_ref = prev;<br />
&#125;<br />
<br />
<code className='keywords'>void</code> main() &#123;<br />
   insertFirst(1,10);<br />
   insertFirst(2,20);<br />
   insertFirst(3,30);<br />
   insertFirst(4,1);<br />
   insertFirst(5,40);<br />
   insertFirst(6,56); <br />
   <br />
   <code className='library'> printf</code>("Original List: "); <br />
   <br />
   <code className='comment'> //print list</code><br />
   <code className='library'> printList</code>();<br />
   <br />
   <code className='library'>while</code>(!isEmpty()) <br />&#123;      <br />      
      struct node *temp = deleteFirst();<br />
      <code className='library'>  printf</code>("\nDeleted value:");<br />
      <code className='library'>  printf</code>("(%d,%d) ",temp-&gt;key,temp-&gt;data);<br />
   &#125;  <br />
   <br />
   <code className='library'> printf</code>("\nList after deleting all items: ");<br />
   <code className='library'> printList</code>();<br />
   insertFirst(1,10);<br />
   insertFirst(2,20);<br />
   insertFirst(3,30);<br />
   insertFirst(4,1);<br />
   insertFirst(5,40);<br />
   insertFirst(6,56);<br />
   <br />
   <code className='library'>printf</code> ("\nRestored List: ");<br />
   <code className='keywords'> printList</code>();<br />
   <code className='library'> printf</code>("\n");  <br />
   <br />
   <code className='keywords'> struct</code> node *foundLink = find(4);<br />
   <br />
   <code className='keywords'>  if </code>(foundLink != NULL) &#123;<br />
      printf("Element found: ");<br />
      printf("(%d,%d) ",foundLink-&gt;key,foundLink-&gt;data);<br />
      printf("\n");  <br />
   &#125; else &#123;<br />
   <code className='keywords'>  printf</code>  ("Element not found.");<br />
   &#125;<br />
   <br />
   delete(4);<br />
   <code className='library'> printf</code>("List after deleting an item: ");<br />
   <code className='keywords'>printList</code> ();<br />
   <code className='library'> printf</code>("\n");<br />
   foundLink = find(4);<br />
   <br />
   <code className='keywords'> if</code>(foundLink != NULL) &#123;<br />
   <code className='library'>  printf</code> ("Element found: ");<br />
   <code className='library'>  printf</code> ("(%d,%d) ",foundLink-&gt;key,foundLink-&gt;data);<br />
   <code className='library'>  printf</code> ("\n");<br />
   &#125; <code className='keywords'> else</code> &#123;<br />
   <code className='library'> printf</code>("Element not found.");<br />
   &#125;<br />
   <br />
   <code className='library'> printf</code>("\n");<br />
   <code className='keywords'>sort()</code>;<br />
   <br />
   <code className='library'> printf</code>("List after sorting the data: ");<br />
   <code className='library'> printList</code>();<br />
   <br />
   <code className='keywords'> reverse</code>(&head);<br />
   <code className='library'> printf</code>("\nList after reversing the data: ");<br />
   <code className='library'> printList</code>();<br />
&#125;<br />
                  </div>
        </div>
    )
}

export default Linked_list
